import ReactCountryFlag from 'react-country-flag'
import useI18n from '@/shared/hooks/useI18n'
import { TableCell, TableRow } from '@/common/components/Table/Table'
import { Partnership, PartnershipInviterOrganizationType } from '@/common'

export default function RejectedImporterRow({ partnership }: { partnership: Partnership }) {
  const { dateFormatter, t } = useI18n()

  const invitationDirectionKey =
    partnership.invitationOrganizationType ===
    PartnershipInviterOrganizationType.OPERATOR
      ? 'outgoing'
      : 'incoming'

  return (
    <TableRow key={partnership.id} className="w-full">
      <TableCell>
        <div className="flex items-start gap-2">
          <ReactCountryFlag countryCode={partnership.country} className="relative top-1" svg />
          {partnership.name}
        </div>
      </TableCell>
      <TableCell>{dateFormatter(new Date(partnership.invitationRejectedAt!))}</TableCell>
      <TableCell>
        <span className="italic">{partnership.invitationRejectedReason || '-'}</span>
      </TableCell>
      <TableCell>
        {t(`importers:importerRejectionList.invitationType.${invitationDirectionKey}`)}
      </TableCell>
    </TableRow>
  )
}
